import insurerPolicy from "../../policies/InsurerPolicy.js";
import { useUser } from "@accredo/fe-shared/hooks/user.js";

export function useInsurerPermissions() {
  const { user } = useUser();

  return {
    canViewAny: () => insurerPolicy.viewAny({ user }),
    canView: (insurer) => insurerPolicy.view({ user, insurer }),
    canUpdateEmail: (insurer) => insurerPolicy.updateEmail({ user, insurer }),
  };
}
